import React from 'react'
import {
  Flex,
  Text,
  Stack,
  Box,
  Container,
  Grid,
  GridItem
} from '@chakra-ui/react'
import Image from 'next/image'
import ourStoryHeaderFooterImage from '@images/our-story-header-footer.png'
import { useResponsive } from '@common/hooks'
import BrandOfJml from '@components/brand-of-jml'

const OurStoryHeaderFooter = () => {
  const { mdMax } = useResponsive()

  return (
    <Box>
      <Grid templateColumns="repeat(12, 1fr)">
        <GridItem
          colSpan={{
            lg: 7,
            base: 12
          }}
          alignItems="center"
          display="flex"
          py={16}
          bg="bgBold"
          data-aos="fade-right"
        >
          <Grid templateColumns="repeat(12, 1fr)" w="100%">
            <GridItem
              colStart={{
                lg: 2,
                base: 1
              }}
              colEnd={{
                lg: 12,
                base: 13
              }}
              px={4}
            >
              <Stack gap={12}>
                <Stack
                  gap={{
                    base: 2
                  }}
                >
                  <Text textStyle="ourStoryTitle">Brand Vision</Text>
                  <Text textStyle="ourStoryTitleMedium" mt={16}>
                    Everyone Deserves A Happy Habitat.
                  </Text>
                  <Text textStyle="ourStoryText" fontWeight={400}>
                    We have a simple vision...we believe that every household
                    can be a happy habitat with simple yet innovative solutions
                    and we are here to enliven that, to make it happen. Every
                    home deserves a Habbit. Sprinkle your life with a little
                    dose of fun. Don’t let the burdens of everyday wear you
                    down. Join us in our pursuit of living good. Carefully
                    curated home and lifestyle products that brightens your day.
                  </Text>
                </Stack>
                <Stack
                  gap={{
                    base: 2
                  }}
                >
                  <Text textStyle="ourStoryTitle">Brand Mission</Text>
                  <Text textStyle="ourStoryTitleMedium">
                    A Habbit in every Habitat.
                  </Text>
                  <Text textStyle="ourStoryText">
                    Bringing innovative home solutions to turn daily chores to
                    happy habits.
                  </Text>
                </Stack>

                <BrandOfJml />
              </Stack>
            </GridItem>
          </Grid>
        </GridItem>

        <GridItem
          colSpan={{
            lg: 5,
            base: 12
          }}
          position="relative"
          minH="100%"
          style={{
            aspectRatio: '820/772'
          }}
          data-aos="fade-left"
        >
          <Image
            src={ourStoryHeaderFooterImage}
            alt="Brand Vision"
            fill
            sizes="100vw"
            style={{
              objectFit: 'cover'
            }}
          />
        </GridItem>
      </Grid>
    </Box>
  )
}

export default OurStoryHeaderFooter
